import React from 'react'
import PropTypes from 'prop-types'
import {getAssetUrl} from '@salesforce/pwa-kit-react-sdk/ssr/universal/utils'
import {Image} from '@salesforce/retail-react-app/app/components/shared/ui'

// 256 from 270 flags from https://github.com/lipis/flag-icons: 4x3 format

// Skip flags are not in COUNTRY_CODES:
// "ARAB": "League of Arab States",
// "CEFTA": "Central European Free Trade Agreement"
// "EAC": "East African Community"
// "ES_CT": "Catalonia"
// "ES_GA": "Galicia"
// "ES_PV": "Basque Country"
// "GB_ENG": "England"
// "GB_NIR": "Northern Ireland"
// "GB_SCT": "Scotland"
// "GB_WLS": "Wales"
// "PC": "Pacific Community"
// "SH_HL": "Saint Helena"
// "SH_TA": "Tristan da Cunha"
// "UN": "United Nations"
// Exception is "XX": "Unknown" to keep for unknown case

// For information: COUNTRY_CODES are not in flags:
// "AN": 'Netherlands Antilles'
// "TA": 'Tristan da Cunha'

// 1. Add the SVG in overrides/app/static/svg.
// 2. Import the SVG.
// 3. When importing the SVG, it will be extracted to a single sprite sheet by the svg-sprite-loader webpack plugin
//    at build time and injected in the <body> tag during SSR.

// Generate flag icons using the imported SVGs
const FlagIcon = ({countryCode = 'XX', ...props}) => {
    return (
        <Image
            src={getAssetUrl(`static/svg/flags/flag-${countryCode.toLowerCase()}.svg`)}
            {...props}
            pointerEvents={'none'}
        />
    )
}

FlagIcon.propTypes = {
    countryCode: PropTypes.string.isRequired
}

export default FlagIcon
